module.exports = __webpack_public_path__ + "assets/Germany.5a60aa25.svg";